import { apiClient } from '@/lib/api-client';
import type { ApiSuccess } from '@/lib/api-client';
import type { BlockerDashboard, DashboardDto, BlockerBatch } from './types';

export const fetchDashboard = async (batchId: string): Promise<DashboardDto> => {
  const res = await apiClient.get<ApiSuccess<DashboardDto>>(
    `/monthly-batches/${batchId}/dashboard`,
  );
  return res.data.data;
};

/** FR-016: cross-batch blocker aggregation for the caller's scope. */
/** Round-6 item 7: the full scoped batch list behind one blocker category. */
export const fetchBlockerBatches = async (
  category: string,
  params: { page?: number; per_page?: number } = {},
): Promise<{ data: BlockerBatch[]; meta: { total: number; page: number; per_page: number } }> => {
  const res = await apiClient.get<
    ApiSuccess<BlockerBatch[], { total: number; page: number; per_page: number }>
  >(`/dashboard/blockers/${encodeURIComponent(category)}/batches`, { params });
  const data = res.data.data ?? [];
  return {
    data,
    meta: res.data.meta ?? { total: data.length, page: params.page ?? 1, per_page: data.length },
  };
};

export const fetchBlockers = async (): Promise<BlockerDashboard> => {
  const res = await apiClient.get<ApiSuccess<BlockerDashboard>>('/dashboard/blockers');
  return res.data.data;
};
